/* YoddhaLabs v11 · the book pages: the book in 3D and Look inside.
   The book in 3D turns by drag (horizontal; vertical scrolling stays the page's) or by the arrow keys.
   Look inside opens a reader in a <dialog>: the opening pages of the printed book, turned with
   page-flip (StPageFlip 2.0.7, MIT), which loads only when the reader first opens. Pictures load a
   few pages ahead of the one shown. Silent. Nothing moves on its own; with reduced motion the pages
   change without the turning animation. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ the book in 3D */
  var REST = -34;   /* at rest the book shows its front and its page edges; drag right to turn to the spine */
  function wrap(a) { a = a % 360; if (a > 180) a -= 360; if (a < -180) a += 360; return a; }
  function sideName(a) {
    a = wrap(a);
    var m = Math.abs(a);
    if (m < 20) return 'The front';
    if (m < 62) return a > 0 ? 'The front and the spine' : 'The front and the page edges';
    if (m < 118) return a > 0 ? 'The spine' : 'The page edges';
    if (m < 160) return a > 0 ? 'The back and the spine' : 'The back and the page edges';
    return 'The back';
  }

  function initBook(root) {
    var stage = root.querySelector('.y11-b3__stage');
    if (!stage) return;
    var ry = REST, rx = -6;
    /* the spine and the back load after the page has, or as soon as the book is touched */
    var woken = false;
    function wake() {
      if (woken) return;
      woken = true;
      Array.prototype.forEach.call(root.querySelectorAll('img[data-src]'), function (img) { showImg(img.parentNode); });
    }
    stage.addEventListener('pointerdown', wake);
    stage.addEventListener('focus', wake);
    if (document.readyState === 'complete') setTimeout(wake, 1500);
    else window.addEventListener('load', function () { setTimeout(wake, 1500); });
    function apply() {
      root.style.setProperty('--b3y', ry + 'deg');
      root.style.setProperty('--b3x', rx + 'deg');
      /* the highlight crosses the front as it turns toward and away from the light */
      var f = Math.max(0, Math.min(100, 50 + wrap(ry) * 1.1));
      root.style.setProperty('--b3sheen', f + '%');
      var v = Math.round(wrap(ry));
      stage.setAttribute('aria-valuenow', String(v));
      stage.setAttribute('aria-valuetext', sideName(ry));
    }
    apply();

    var drag = null;
    /* the pictures are not to be dragged out: that would cancel the turn */
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      drag = { x: e.clientX, y: e.clientY, ry: ry, rx: rx, moved: false, id: e.pointerId, type: e.pointerType };
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        /* on touch, a mostly vertical move is the page scrolling: let it go */
        if (drag.type !== 'mouse' && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
        drag.moved = true;
        root.classList.add('is-dragging');
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      ry = drag.ry + dx * 0.55;
      rx = Math.max(-24, Math.min(16, drag.rx - dy * 0.2));
      apply();
    });
    function end(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var moved = drag.moved;
      drag = null;
      root.classList.remove('is-dragging');
      ry = wrap(ry);
      apply();
      /* a tap (no turn) on the book opens Look inside */
      if (!moved && e && e.type === 'pointerup') {
        var to = root.getAttribute('data-y11-b3-open');
        if (to) openLook(to, 0, stage);
      }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('lostpointercapture', function (e) { if (drag && drag.moved) end(e); });

    stage.addEventListener('keydown', function (e) {
      var k = e.key, step = e.shiftKey ? 45 : 15, done = true;
      if (k === 'ArrowRight' || k === 'ArrowUp') ry += step;
      else if (k === 'ArrowLeft' || k === 'ArrowDown') ry -= step;
      else if (k === 'Home') { ry = REST; rx = -6; }
      else if (k === 'End') { ry = 180 + REST; rx = -6; }
      else if (k === 'PageUp') ry += 90;
      else if (k === 'PageDown') ry -= 90;
      else done = false;
      if (done) { e.preventDefault(); apply(); }
    });
  }

  /* ------------------------------------------------------------------ look inside */
  var pfLoading = null;
  function loadPageFlip(src) {
    if (window.St && window.St.PageFlip) return Promise.resolve();
    if (pfLoading) return pfLoading;
    pfLoading = new Promise(function (ok, no) {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function () { ok(); };
      s.onerror = function () { pfLoading = null; no(new Error('page-flip did not load')); };
      document.head.appendChild(s);
    });
    return pfLoading;
  }

  function showImg(page) {
    if (!page) return;
    var img = page.querySelector('img[data-src]');
    if (!img) return;
    if (img.getAttribute('data-sizes')) img.sizes = img.getAttribute('data-sizes');
    if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  var readers = {};

  function Reader(dlg) {
    this.dlg = dlg;
    this.book = dlg.querySelector('[data-y11-look-book]');
    this.stage = dlg.querySelector('[data-y11-look-stage]');
    this.count = dlg.querySelector('[data-y11-look-count]');
    this.prev = dlg.querySelector('[data-y11-look-prev]');
    this.next = dlg.querySelector('[data-y11-look-next]');
    this.pages = Array.prototype.slice.call(dlg.querySelectorAll('.y11-look__page'));
    this.n = parseInt(dlg.getAttribute('data-n'), 10) || 0;
    this.pw = parseInt(dlg.getAttribute('data-w'), 10) || 1000;
    this.ph = parseInt(dlg.getAttribute('data-h'), 10) || 1545;
    this.pf = null;
    this.opener = null;
    var self = this;

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('y11-locked');
      if (self.opener && document.contains(self.opener)) { var far = self.opener.closest && self.opener.closest('[data-y11-look-open]') ? true : false; try { self.opener.focus({ preventScroll: far }); } catch (e) { self.opener.focus(); } }
    });
    dlg.addEventListener('click', function (e) {
      var c = e.target.closest('[data-y11-look-close]');
      if (c) {
        var href = c.getAttribute('href');
        if (!href) e.preventDefault();
        /* a link to a part of the page: focus lands there, not back on the button that opened the reader */
        else if (href.charAt(0) === '#') { var to = document.getElementById(href.slice(1)); if (to && to.hasAttribute('tabindex')) self.opener = to; }
        dlg.close();
        return;
      }
      /* a press on the dark room around the book closes it */
      if (e.target === dlg) dlg.close();
    });
    this.prev.addEventListener('click', function () { self.turn(-1); });
    this.next.addEventListener('click', function () { self.turn(1); });
    dlg.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); self.turn(1); }
      else if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); self.turn(-1); }
      else if (e.key === 'Home') { e.preventDefault(); self.go(0); }
      else if (e.key === 'End') { e.preventDefault(); self.go(self.pages.length - 1); }
    });
    var t = null;
    window.addEventListener('resize', function () {
      if (!dlg.open || !self.pf) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var was = self.spread, at = self.pf.getCurrentPageIndex();
        self.size();
        if (self.spread !== was) { self.rebuild(at); return; }
        self.pf.update(); self.label();
      }, 120);
    });
  }

  /* the book's box: two pages wide on a wide screen, one on a phone, always inside the room */
  Reader.prototype.size = function () {
    var cs = getComputedStyle(this.stage);
    var w = this.stage.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var h = this.stage.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var r = this.pw / this.ph;
    var spread = w >= 720;
    var bw = spread ? Math.min(w, h * r * 2) : Math.min(w, h * r);
    var bh = spread ? bw / 2 / r : bw / r;
    this.book.style.width = Math.floor(bw) + 'px';
    this.book.style.height = Math.floor(bh) + 'px';
    this.spread = spread;
    return { w: Math.floor(spread ? bw / 2 : bw), h: Math.floor(bh) };
  };

  Reader.prototype.build = function () {
    var self = this;
    var dims = this.size();
    /* page-flip owns (and on destroy removes) its root, so it gets a fresh one inside the book */
    var host = document.createElement('div');
    host.className = 'y11-look__host';
    this.book.appendChild(host);
    this.host = host;
    this.pf = new window.St.PageFlip(host, {
      width: dims.w, height: dims.h,
      size: 'stretch',
      /* one page wide: a minimum page width above half the box makes page-flip choose portrait */
      minWidth: this.spread ? 160 : dims.w, maxWidth: 1400, minHeight: 240, maxHeight: 2200,
      autoSize: false,
      showCover: true,
      usePortrait: !this.spread,
      drawShadow: true,
      maxShadowOpacity: 0.35,
      flippingTime: reduce ? 1 : 750,
      showPageCorners: !reduce,
      mobileScrollSupport: false,
      swipeDistance: 24
    });
    this.pf.loadFromHTML(this.pages);
    this.pf.on('flip', function () { self.after(); });
    this.pf.on('changeOrientation', function () { self.after(); });
  };

  /* two pages wide and one wide are two different books to page-flip: switching rebuilds it */
  Reader.prototype.rebuild = function (at) {
    var self = this;
    this.pf.clear();
    this.pages.forEach(function (p) { p.removeAttribute('style'); self.book.appendChild(p); });
    this.pf.destroy();
    this.pf = null;
    this.build();
    this.go(at || 0);
  };

  Reader.prototype.after = function () {
    var i = this.pf ? this.pf.getCurrentPageIndex() : 0;
    for (var j = i - 2; j <= i + 5; j++) showImg(this.pages[j]);
    this.label();
  };

  Reader.prototype.label = function () {
    if (!this.pf) return;
    var i = this.pf.getCurrentPageIndex();
    var last = this.pages.length - 1;
    var landscape = this.pf.getOrientation() === 'landscape';
    var text;
    var cls = this.dlg.classList;
    cls.toggle('is-cover', i === 0);
    cls.toggle('is-end', i >= last);
    cls.toggle('is-spread', landscape);
    /* short words on a phone, where the bar is narrow */
    if (i === 0) text = landscape ? 'The cover' : 'Cover';
    else if (i >= last || i > this.n) text = landscape ? 'The end of the preview' : 'The end';
    else if (landscape && i + 1 <= this.n) text = 'Pages ' + i + '–' + (i + 1) + ' of ' + this.n;
    else text = landscape ? 'Page ' + i + ' of ' + this.n : i + ' of ' + this.n;
    this.count.textContent = text;
    this.prev.disabled = i <= 0;
    this.next.disabled = i >= last || (landscape && i + 1 >= last);
  };

  Reader.prototype.turn = function (dir) {
    if (!this.pf) return;
    if (reduce) { if (dir > 0) this.pf.turnToNextPage(); else this.pf.turnToPrevPage(); this.after(); }
    else { if (dir > 0) this.pf.flipNext(); else this.pf.flipPrev(); }
  };

  Reader.prototype.go = function (page) {
    if (!this.pf) return;
    page = Math.max(0, Math.min(this.pages.length - 1, page));
    this.pf.turnToPage(page);
    this.after();
  };

  Reader.prototype.open = function (page, opener) {
    var self = this;
    this.opener = opener || document.activeElement;
    for (var j = 0; j < 4; j++) showImg(this.pages[j]);
    if (page) for (var k = page - 1; k <= page + 3; k++) showImg(this.pages[k]);
    if (typeof this.dlg.showModal === 'function') this.dlg.showModal(); else this.dlg.setAttribute('open', '');
    document.documentElement.classList.add('y11-locked');
    this.count.textContent = 'Opening the book…';
    loadPageFlip(this.dlg.getAttribute('data-pf')).then(function () {
      if (!self.pf) self.build();
      else { self.size(); self.pf.update(); }
      self.go(page || 0);
      self.next.focus();
    }).catch(function () {
      self.count.textContent = 'The pages could not be loaded. Please try again.';
    });
  };

  function openLook(id, page, opener) {
    var dlg = document.getElementById(id);
    if (!dlg) return;
    if (!readers[id]) readers[id] = new Reader(dlg);
    readers[id].open(page || 0, opener);
  }

  /* ------------------------------------------------------------------ wiring */
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-y11-b3]'), initBook);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-y11-look-open]');
      if (!b || b.hasAttribute('data-y11-b3')) return;
      e.preventDefault();
      openLook(b.getAttribute('data-y11-look-open'), parseInt(b.getAttribute('data-y11-look-page'), 10) || 0, b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
